

















import dayjs from "dayjs";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ServiceStatusUpdateArea extends Vue {
  @Prop({ default: null }) private updatedTime!: number | null;
  @Prop({ default: false }) private loading!: boolean;

  private get datetime(): string {
    if (this.updatedTime === null) {
      return "-";
    }

    return `${dayjs(this.updatedTime).format("YYYY/MM/DD HH:mm:ss")}`;
  }
}
